import axios from "axios";

export function getNoticeList(co) {
  const config = {
    params: co,
  };
  return axios.get(process.env.VUE_APP_API_URL + "Notice/getlist", config);
}

export function getNoticeById(noticeId) {
  const config = {
    params: {
      noticeId: noticeId,
    },
  };

  return axios.get(process.env.VUE_APP_API_URL + "Notice/getbyid", config);
}

export function postNotice(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Notice/add", data, config);
}

export function updateNotice(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.put(process.env.VUE_APP_API_URL + "Notice/update", data, config);
}

export function deleteNotice(noticeId) {
  const config = {
    params: {
      noticeId: noticeId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "Notice/deleted", config);
}

//Notice Uploads
export function getNoticeUploadListByNoticeId(noticeId) {
  const config = {
    params: {
      noticeId: noticeId,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "NoticeUpload/getlistnoticeid", config);
}

export function getNoticeUploadList() {
  return axios.get(process.env.VUE_APP_API_URL + "NoticeUpload/getlist");
}

export function postNoticeUpload(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "NoticeUpload/add", data, config);
}

export function deleteNoticeUpload(noticeUploadId) {
  const config = {
    params: {
      noticeUploadId: noticeUploadId,
    },
  };

  return axios.delete(process.env.VUE_APP_API_URL + "NoticeUpload/deleted", config);
}
